import { Box, Typography } from '@mui/material';
import { DataAccordion } from '../../../../../../shared-components/DataAccordion';
import DashboardEmissionsTable from '../../../shared-components/DashboardEmissionsTable'
import { useDispatch, useSelector } from 'react-redux';
import { scopeThreeEmissionColumns, scopeThreeTitle } from '../../../constants/dashboard-constants';
import { useEffect } from 'react';
import { getCompanyEmissionsScopeThree } from '../../../../../../../actions/carbonfootprint-rework/07-emission-factors/01-emission-factors';


export default function ScopeThreeEmissionsOverview({ openAccordion, changeAccordion, companyId, companyName, year }) {
    const dispatch = useDispatch()
    const accordionName = 'Scope Three Emissions Overview'
    const isLoading = useSelector((state) => (state.emissionFactorsReducer?.companyScopeThreeLoading))
    const columns = scopeThreeEmissionColumns(companyName)
    const scopeThreeEmissionRows = useSelector((state) => (state.emissionFactorsReducer?.companyEmissionsScopeThree?.data))

    useEffect(() => {
        if (openAccordion === accordionName) {
            dispatch(getCompanyEmissionsScopeThree(companyId, year))
        }
    }, [dispatch,
        openAccordion,
        companyId,
        year])

    return (
        <DataAccordion
            title={scopeThreeTitle}
            show={openAccordion === accordionName}
            handleChange={() => changeAccordion(accordionName)}
        >
            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', gap: 2 }}>
                <Typography variant='h6'>
                    Scope Three Emissions for {companyName} in {year}:
                </Typography>
                <DashboardEmissionsTable loading={isLoading} columns={columns} rows={scopeThreeEmissionRows} />
            </Box>
        </DataAccordion>
    )
}